module.controller(
    'productCategoryListCtrl',
    [ '$scope', '$rootScope', '$state', 'productCategoryService', 'alertService', 'roleService', 'parameterService',
        function($scope, $rootScope, $state, productCategoryService, alertService, roleService, parameterService) {

            $scope.filter = {
                
            };
            $scope.productCategories = [];
            

            /**
             *
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;
                var filter = {
                		name : $scope.filter.name 
                };
                
                productCategoryService.searchTree(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.productCategories = result;
                }, function(response) {
                    $scope.loading = false;
                });                
            };

            
            $scope.removeCategory = function(idCategory) {
                alertService.showSwtQuestion('Eliminar categoría de producto', function() {
                    $scope.loading = true;

                    productCategoryService.deleteProductCategory(idCategory).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Categoría de producto eliminada satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.clearFilters = function(){
                $scope.filter = {};
            };

            $scope.search();

        } ]);
